/* Brand storefront behaviour v2: drawers, AJAX cart, after-add mode, variant picker, gallery, swipers, FAQ, footer accordions. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Drawers ---------- */
  var overlay = $('[data-b-overlay]');
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    $$('.b-drawer.is-open').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); });
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input');
    if (f) f.focus();
  }
  function closeDrawers() {
    $$('.b-drawer.is-open').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-b-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-b-open')); return; }
    if (e.target.closest('[data-b-close]') || e.target === overlay) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('.b-drawer.is-open')) closeDrawers();
    if (e.key === 'Tab') {
      var d = $('.b-drawer.is-open');
      if (!d) return;
      var items = $$('a[href], button:not([disabled]), input, select', d).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-b-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }
  function refreshDrawer() {
    return fetch(root + '?sections=b-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['b-cart-drawer'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-b-cart-inner]');
          var current = $('[data-b-cart-inner]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) updateCount(cart.item_count); });
  }
  function afterAddMode() {
    var d = document.getElementById('b-cart');
    return (d && d.getAttribute('data-b-after-add')) || 'drawer';
  }
  function showError(form, msg) {
    var box = form.querySelector('[data-b-error]');
    if (box) { box.textContent = msg; box.hidden = !msg; }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-b-add]');
    if (!form) return;
    e.preventDefault();
    var btns = $$('[type="submit"]', form);
    if (form.id) btns = btns.concat($$('[form="' + form.id + '"][type="submit"]'));
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; b.setAttribute('data-b-prev', b.textContent); b.textContent = 'Adding…'; });
    showError(form, '');
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { showError(form, res.body.description || res.body.message || 'Could not add to cart.'); return; }
        var mode = afterAddMode();
        if (mode === 'checkout') { window.location.assign(root + 'checkout'); return; }
        if (mode === 'cart') { window.location.assign(root + 'cart'); return; }
        return refreshDrawer().then(function () { openDrawer('b-cart'); });
      })
      .catch(function () { showError(form, 'Network error — please try again.'); })
      .finally(function () {
        btns.forEach(function (b) {
          b.removeAttribute('aria-busy');
          if (b.hasAttribute('data-b-prev')) { b.textContent = b.getAttribute('data-b-prev'); b.removeAttribute('data-b-prev'); }
          if (!b.hasAttribute('data-b-soldout')) b.disabled = false;
        });
      });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b-line]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-b-line'), 10), quantity: parseInt(b.getAttribute('data-b-qty'), 10) })
    }).then(function () {
      if (document.body.getAttribute('data-template') === 'cart') { window.location.reload(); return; }
      return refreshDrawer();
    });
  });

  /* ---------- Gallery (scroll-snap track) ---------- */
  function galleryGo(g, idx) {
    var track = g.querySelector('[data-b-gal-track]');
    if (!track) return;
    var slides = $$('[data-b-slide]', track);
    if (!slides[idx]) return;
    track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  function galleryIndex(g) {
    var track = g.querySelector('[data-b-gal-track]');
    return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0;
  }
  $$('[data-b-gal]').forEach(function (g) {
    var track = g.querySelector('[data-b-gal-track]');
    if (!track) return;
    var sync = function () {
      var i = galleryIndex(g);
      $$('[data-b-thumb]', g).forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      $$('[data-b-dot]', g).forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-b-thumb]');
      if (t) { galleryGo(g, parseInt(t.getAttribute('data-b-thumb'), 10)); return; }
      var a = e.target.closest('[data-b-gal-arrow]');
      if (a) {
        var n = $$('[data-b-slide]', track).length;
        var i = galleryIndex(g) + (a.getAttribute('data-b-gal-arrow') === 'next' ? 1 : -1);
        galleryGo(g, (i + n) % n);
      }
    });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-b-product]').forEach(function (scope) {
    var dataEl = scope.querySelector('[data-b-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = scope.querySelector('form[data-b-add]');
    var idInput = form && form.querySelector('input[name="id"]');
    var money = scope.getAttribute('data-b-money') || '${{amount}}';
    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    function selected() {
      return $$('[data-b-option]', scope).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function apply() {
      var sel = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      $$('[data-b-selected-label]', scope).forEach(function (el, i) { el.textContent = sel[i] || ''; });
      var buttons = $$('[data-b-atc]');
      if (!v) { buttons.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; }); return; }
      if (idInput) idInput.value = v.id;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-b-price-now]').forEach(function (el) { el.textContent = fmt(v.price); });
      $$('[data-b-price-was]').forEach(function (el) { el.hidden = !sale; if (sale) el.textContent = fmt(v.compare_at_price); });
      $$('[data-b-price-save]').forEach(function (el) {
        el.hidden = !sale;
        if (sale) el.textContent = el.hasAttribute('data-b-percent')
          ? 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'
          : 'Save ' + fmt(v.compare_at_price - v.price);
      });
      var stock = scope.querySelector('[data-b-stock]');
      if (stock) {
        stock.hidden = !(v.available && v.low_qty > 0);
        if (v.low_qty > 0) stock.textContent = 'Only ' + v.low_qty + ' left in stock';
      }
      buttons.forEach(function (b) {
        if (v.available) { b.disabled = false; b.removeAttribute('data-b-soldout'); b.textContent = b.getAttribute('data-b-label') || 'Add to cart'; }
        else { b.disabled = true; b.setAttribute('data-b-soldout', ''); b.textContent = 'Sold out'; }
      });
      if (v.media_id) {
        var g = scope.querySelector('[data-b-gal]');
        var slide = g && g.querySelector('[data-b-media-id="' + v.media_id + '"]');
        if (slide) galleryGo(g, parseInt(slide.getAttribute('data-b-slide'), 10));
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    scope.addEventListener('change', function (e) { if (e.target.closest('[data-b-option]')) apply(); });
    var sticky = $('[data-b-sticky]');
    var main = scope.querySelector('[data-b-atc-main]');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(main);
    }
  });

  /* ---------- Swipers: arrows + progress ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b-rail-btn]');
    if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls'));
    if (rail) rail.scrollBy({ left: (b.getAttribute('data-b-rail-btn') === 'next' ? 1 : -1) * rail.clientWidth * 0.8, behavior: 'smooth' });
  });
  $$('[data-b-progress]').forEach(function (p) {
    var rail = document.getElementById(p.getAttribute('data-b-progress'));
    var bar = p.querySelector('.b-progress__bar');
    if (!rail || !bar) return;
    var update = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
      bar.style.width = Math.max(ratio * 100, 12) + '%';
      var pos = max > 0 ? rail.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (pos * (100 / Math.max(ratio, 0.12) - 100)) + '%)';
      p.hidden = max <= 1;
    };
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Video cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b-play]');
    if (!b) return;
    var card = b.closest('.b-vid');
    var v = card && card.querySelector('video');
    if (!v) return;
    $$('.b-vid video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.b-vid').classList.remove('is-playing'); } });
    v.controls = true; v.play(); card.classList.add('is-playing');
  });

  /* ---------- FAQ "View more" ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b-faq-more]');
    if (!b || b.tagName === 'A') return;
    var list = document.getElementById(b.getAttribute('aria-controls'));
    if (!list) return;
    $$('.b-faq__item.is-hidden', list).forEach(function (i) { i.classList.remove('is-hidden'); });
    b.hidden = true;
  });

  /* ---------- Footer accordions: open on desktop, closed on mobile ---------- */
  var mq = window.matchMedia('(max-width: 749px)');
  function setFooter() { $$('.b-fcol').forEach(function (d) { d.open = !mq.matches; }); }
  setFooter();
  if (mq.addEventListener) mq.addEventListener('change', setFooter);
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.b-fcol > summary');
    if (s && !mq.matches) e.preventDefault();
  });

  /* ---------- Announcement rotation ---------- */
  var items = $$('.b-announce__item');
  if (items.length) items[0].classList.add('is-active');
  if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var i = 0;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000);
  }
})();
